import { endpoint } from '@library/endpoint'

import { fetch } from 'utils/fetch'

export function trackOrder(reqData?: Record<string, unknown>) {
  return fetch(
    null,
    `${endpoint('customers', 1)}/customers/track-order`,
    reqData,
    'POST',
    'default',
    {
      'Content-Type': 'application/json',
    },
  )
}
